import i18n from 'i18next';
import { ECounterpartyType } from '../enums/payments.enums';

export const COUNTERPARTY_TYPE_OPTIONS = [
  {
    value: ECounterpartyType.Bank,
    label: i18n.t('paymentOperation.form.label.type.bank') as string,
  },
  {
    value: ECounterpartyType.Customer,
    label: i18n.t('paymentOperation.form.label.type.customer') as string,
  },
];

export const SHOULD_SHOW_SCHEDULED_PAYMENT = false;
